<template>
  <SidebarSettingsGroup
    title="Settings"
    collapsible
    :element-type="element.type"
    data-test="graphics-slideshowSettings-settings"
  >
    <cycle-time-settings v-model:cycle-time="cycleTime" />
    <hr class="sidebar-divider" />

    <div class="settings-row settings-row-xs">
      <div class="settings-col-12 settings-col-xs">
        <label class="checkbox header-checkbox">Add progress visual
          <input
            v-model="hasProgressIndicator"
            type="checkbox"
            data-test="graphics-slideshowSettings-toggleProgressIndicator"
            data-entity="graphics-slideshowSettings-toggleProgressIndicator"
          />
          <div class="checkmark">
            <span class="checkmark-tick fa-solid fa-check"></span>
          </div>
        </label>
        <span class="text-tiny">Add a visual progression indicator for the slides in the slideshow
          widget in either a social "Stories" or single progress visual</span>
      </div>
    </div>

    <div class="sidebar-form-group">
      <div
        v-if="hasProgressIndicator"
        class="sidebar-sub-group progress-position-setting"
        data-test="graphics-slideshowSettings-progressPosition"
      >
        <div class="settings-row settings-row-xs">
          <div class="settings-col-12 settings-col-xs">
            <label class="sidebar-form-label">Progress indicator style</label>
            <select
              v-model="progressIndicatorStyle"
              data-test="graphics-slideshowSettings-selectProgressIndicatorStyle"
              data-entity="graphics-slideshowSettings-selectProgressIndicatorStyle"
            >
              <option value="stories">
                Stories
              </option>
              <option value="single">
                Slide progress bar
              </option>
            </select>
          </div>
        </div>

        <position-settings
          :element="virtualProgressIndicator"
          v-model:pos-x="PIPosX"
          v-model:pos-y="PIPosY"
          v-model:width="PIWidth"
          v-model:height="PIHeight"
        />

        <div class="settings-row settings-row-xs">
          <div class="settings-col-3 settings-col-xs colorpicker">
            <colorpicker v-model="barFillColor" />
          </div>
          <div class="settings-col-3 settings-col-xs colorpicker">
            <colorpicker v-model="barBackgroundColor" />
          </div>
        </div>
      </div>
    </div>
  </SidebarSettingsGroup>
</template>

<script>
import { mapGetters } from 'vuex';
import SettingsMixins from '../../mixins/settings-mixins';

import PositionSettings from './Position.vue';
import CycleTimeSettings from './CycleTime.vue';

export default {
  components: {
    PositionSettings,
    CycleTimeSettings,
  },
  mixins: [SettingsMixins],
  props: ['element'],
  data() {
    return {
      piId: `virtual-progress-indicator-${this.element.id}`,
    };
  },
  computed: {
    ...mapGetters('graphicsTemplate', [
      'getElementById',
    ]),
    cycleTime: {
      get() {
        return this.element.cycleTime;
      },
      set(v) {
        this.updateOneElementValue('cycleTime', v);
      },
    },
    hasProgressIndicator: {
      get() {
        return this.element.hasProgressIndicator;
      },
      set(v) {
        this.updateOneElementValue('hasProgressIndicator', v);
      },
    },
    virtualProgressIndicator() {
      return this.getElementById(this.piId);
    },
    progressIndicatorStyle: {
      get() {
        return this.virtualProgressIndicator.progressIndicatorStyle;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'progressIndicatorStyle',
            propValue: v,
          },
        });
      },
    },
    PIPosX: {
      get() {
        return this.virtualProgressIndicator.styles.left;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'styles.left',
            propValue: v,
          },
        });
      },
    },
    PIPosY: {
      get() {
        return this.virtualProgressIndicator.styles.top;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'styles.top',
            propValue: v,
          },
        });
      },
    },
    PIWidth: {
      get() {
        return this.virtualProgressIndicator.styles.width;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'styles.width',
            propValue: v,
          },
        });
      },
    },
    PIHeight: {
      get() {
        return this.virtualProgressIndicator.styles.height;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'styles.height',
            propValue: v,
          },
        });
      },
    },
    barFillColor: {
      get() {
        return this.virtualProgressIndicator.barFillColor;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'barFillColor',
            propValue: v,
          },
        });
      },
    },
    barBackgroundColor: {
      get() {
        return this.virtualProgressIndicator.barBackgroundColor;
      },
      set(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.piId,
            propKey: 'barBackgroundColor',
            propValue: v,
          },
        });
      },
    },
  },
};
</script>
